import { render, staticRenderFns } from "./MailLogoBase64.vue?vue&type=template&id=45f8a396&scoped=true"
import script from "./MailLogoBase64.vue?vue&type=script&lang=js"
export * from "./MailLogoBase64.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45f8a396",
  null
  
)

export default component.exports